import { BookOpen } from "lucide-react";
import { Logo } from "./Logo";
import { EoiLink } from "./EoiLink";

const SOCIALS = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/vanguardprepschool/",
    testid: "footer-social-link-instagram",
  },
  {
    label: "Facebook",
    href: "https://www.facebook.com/share/16NBbnyHSZQ/?mibextid=wwXIfr",
    testid: "footer-social-link-facebook",
  },
];

const ICONS = {
  Instagram: () => (
    <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="0.5" fill="currentColor"/></svg>
  ),
  Facebook: () => (
    <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor"><path d="M24 12.07C24 5.4 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.09 10.13 24v-8.44H7.08v-3.49h3.05V9.41c0-3.02 1.79-4.7 4.53-4.7 1.31 0 2.68.24 2.68.24v2.97h-1.51c-1.49 0-1.96.93-1.96 1.89v2.26h3.33l-.53 3.49h-2.8V24C19.61 23.09 24 18.1 24 12.07Z"/></svg>
  ),
};

export const Footer = () => (
  <footer className="relative overflow-hidden bg-navy-deep text-slate-300">
    <div className="mx-auto max-w-7xl px-4 pt-14 sm:px-6 lg:px-12">
      <div className="flex flex-col gap-10 pb-12 md:flex-row md:items-start md:justify-between">
        <div className="max-w-sm">
          <div className="flex items-center gap-3">
            <Logo className="h-10 w-10" />
            <div>
              <p className="font-serif text-lg font-bold tracking-wide text-white">VPS</p>
              <p className="font-mono text-[10px] tracking-[0.25em] text-slate-400">
                WHERE CHARACTER MEETS ACADEMIC EXCELLENCE
              </p>
            </div>
          </div>
          <p className="mt-5 text-sm leading-relaxed text-slate-400">
            A new charter school for Years 7–10, opening Term 1, 2027.
            Expressions of interest for the foundation intake are now open.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <p className="font-mono text-[10px] tracking-[0.25em] text-gold">ENROLMENTS</p>
          <EoiLink
            testid="footer-eoi-link"
            className="text-sm text-slate-300 transition-colors duration-300 hover:text-gold"
          >
            Express Your Interest
          </EoiLink>
          <a href="/#ethos" className="text-sm text-slate-300 transition-colors duration-300 hover:text-gold">Our Ethos</a>
          <a href="/#key-dates" className="text-sm text-slate-300 transition-colors duration-300 hover:text-gold">Key Dates</a>
          <a href="/privacy-policy" data-testid="footer-privacy-link" className="text-sm text-slate-300 transition-colors duration-300 hover:text-gold">Privacy Policy</a>
          <a href="/terms-of-use" data-testid="footer-terms-link" className="text-sm text-slate-300 transition-colors duration-300 hover:text-gold">Terms of Use</a>
        </div>

        <div className="flex flex-col gap-3">
          <p className="font-mono text-[10px] tracking-[0.25em] text-gold">CONTACT</p>
          <div className="mt-2 flex items-center gap-3">
            {SOCIALS.map(({ label, href, testid }) => {
              const Icon = ICONS[label];
              return (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  data-testid={testid}
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-slate-400 transition-colors duration-300 hover:border-gold/60 hover:text-gold"
                >
                  <Icon />
                </a>
              );
            })}
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-2 border-t border-white/10 py-6 sm:flex-row sm:items-center sm:justify-between">
        <p className="font-mono text-[10px] tracking-[0.2em] text-slate-500">
          © 2026 VPS. ALL RIGHTS RESERVED.
        </p>
        <p className="flex items-center gap-2 font-mono text-[10px] tracking-[0.2em] text-slate-500">
          <BookOpen className="h-3 w-3" /> OPENING TERM 1, 2027
        </p>
      </div>
    </div>

    <p
      aria-hidden="true"
      className="pointer-events-none select-none text-center font-serif text-[24vw] font-bold leading-[0.75] tracking-tight text-white/[0.04]"
    >
      VPS
    </p>
  </footer>
);
